class StickyTools {
  constructor($wrap) {
    this.$tools = $wrap;
    this.toolsRect = this.$tools.getBoundingClientRect();
    this.$clone = this.$tools.cloneNode(true);

    this.toggleSticky();
    this.init();
  }

  deconstructor() {
    window.removeEventListener('scroll', this.toggleSticky);
    document.body.removeChild(this.$clone);
  }

  toggleSticky = () => {
    const toolsRect = this.$tools.getBoundingClientRect();
    const contentEnd = document.querySelector('.page__content').getBoundingClientRect();
    const scrollTop = window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
    const clientTop = document.documentElement.clientTop || document.body.clientTop || 0;
    const top = Math.round(((toolsRect.top - 10) + scrollTop) - clientTop);
    const bottom = Math.round(((contentEnd.bottom + scrollTop) - clientTop) -
                              (this.$clone.offsetHeight + 100));
    const isBottom = scrollTop >= bottom;

    if (scrollTop >= top && !isBottom) {
      this.$clone.classList.add('article__tools-mobile--sticky');
    } else {
      this.$clone.classList.remove('article__tools-mobile--sticky');
    }
  }

  init() {
    this.$clone.classList.add('article__tools-mobile');
    this.$clone.classList.remove('article__tools-wrap');
    document.body.appendChild(this.$clone);
    window.addEventListener('scroll', this.toggleSticky);

    // initiate print button for clone
    this.$clone.querySelector('.js-print').addEventListener('click', (event) => {
      event.preventDefault();
      window.print();
    });
  }
}

const mql = window.matchMedia('(min-width: 1090px)');

// Event registry
let eventRegistry = [];
// Toggle button for main menu and ministry flyout
let stickytools = null;

function onMediaQueryChange(mq) {
  const isDesktop = mq.matches;
  // Kill all event handlers on switch
  eventRegistry.forEach(e => e());
  eventRegistry = [];

  // Deinit on desktop
  if (isDesktop && stickytools) {
    stickytools.deconstructor();
    stickytools = null;
  // Init on mobile
  } else if (!isDesktop && !stickytools) {
    const $tools = document.querySelector('.article__tools-wrap');
    if ($tools && !$tools.classList.contains('article__tools-wrap--inline')) {
      stickytools = new StickyTools($tools);
    }
  }
}

mql.addListener(onMediaQueryChange);
onMediaQueryChange(mql);
